module.exports = __webpack_public_path__ + "../../dist/frontend-shortcode-appointment-module/assets/img/visuel-fissure.png";